import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuscaChips } from './busca-chips.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ComponentesService } from '../componentes.service';

@NgModule({
  declarations: [
    BuscaChips
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatIconModule
  ],
  exports: [
    BuscaChips
  ],
  providers: [
    ComponentesService
  ]
})
export class BuscaChipsModule { }
